export default __webpack_public_path__ + "static/mp-c9fb20750855eeafa6189245b189ccf6.svg";